import React, { useState, useEffect, useContext, useMemo } from "react";
import { editTeacherProfile, bulkDeleteFreeSlots, getTeacherMappedCourses, type BulkDeleteFreeSlotsScope } from "../../../../Api/apiUtils";
import { Modal, ModalBody, ModalFooter, ModalHeader, Form, Input } from 'reactstrap';
import { EnterFirstName, EnterLastName, MiddleName, EmailJobPlaceholder, BirthDateJob, DelimiterPlaceholder, Qualifications } from '../../../../utils/Constant';
import Select, { MultiValue } from "react-select";
import { Button, Field, Loader, Select as DsSelect, TextInput } from "../../../../ui";
import type { SelectOption } from "../../../../ui";
import { SegmentedControl } from "./ui-pending";
import SwitchField from "./ui-pending/SwitchField";
import './formProfile.scss';
import { toast } from "react-toastify";
import { ConfigContext } from "../../../../Api/global/ApiContext";
import { MixpanelEvents,trackEvent } from "../../../../utils/mixpanelTracking";
import { isTeacherLeaderDisabled } from "../../../../utils/permissions";
import { hasEmailAccess, useEmailAccessConfig } from "../../../../utils/emailAccessConfig";

interface profileProps {
teacherDetails:any
  credentialId: any;
  teacherId: any;
  fetchData: () => Promise<void>; 

}

const stepTitles = ["Personal Details", "Academic Details", "Employment & Eligibility", "Other Preferences & Courses"];
const STEP_ICONS = ["fa-user", "fa-graduation-cap", "fa-briefcase", "fa-check-circle"];

const TITLE_OPTIONS: SelectOption[] = [
  { value: "", label: "Select Title" },
  { value: "Mr", label: "Mr" },
  { value: "Mrs", label: "Mrs" },
  { value: "Miss", label: "Miss" },
];
const PAYOUT_OPTIONS: SelectOption[] = ["SILVER", "GOLD", "PLATINUM", "DIAMOND"].map((v) => ({ value: v, label: v }));
const TRUE_FALSE_OPTIONS: SelectOption[] = [
  { value: "True", label: "True" },
  { value: "False", label: "False" },
];
const EMPLOYMENT_OPTIONS: SelectOption[] = [
  { value: "Full-Time", label: "Full-Time" },
  { value: "Part-Time", label: "Part-Time" },
];

function formatLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** AE demo disable: scheduler bulk-delete free slots always uses AIRLINE scope only */
const AE_DEMO_DISABLE_BULK_SCOPE: BulkDeleteFreeSlotsScope[] = ["AIRLINE"];

/** Today through the same calendar day two months ahead (for AE airline free-slot bulk delete). */
function aeAirlineBulkDeleteRange(): { fromDate: string; toDate: string } {
  const from = new Date();
  const to = new Date(from.getTime());
  to.setMonth(to.getMonth() + 2);
  return { fromDate: formatLocalYmd(from), toDate: formatLocalYmd(to) };
}

const FormProfile: React.FC<profileProps> = ({ credentialId, teacherId, teacherDetails, fetchData }) => {
  const readOnly = isTeacherLeaderDisabled();
  useEmailAccessConfig();
  const isAllowed = hasEmailAccess("teacherFormRestricted");
 

  console.log("teacher",teacherDetails)
    const [isLoading, setIsLoading] = useState(true);
    const [showConfirmation, setShowConfirmation] = useState(false);
  const [pendingValue, setPendingValue] = useState(false);
  const [pendingToggleType, setPendingToggleType] = useState<'skipHours' | 'isAcademicExpert' | null>(null);
  const [pendingPreviousIsAcademicExpert, setPendingPreviousIsAcademicExpert] = useState(false);
  const [showAeDemoDisableModal, setShowAeDemoDisableModal] = useState(false);
  const [aeDemoModalBusy, setAeDemoModalBusy] = useState(false);
  const [aeDemoModalAction, setAeDemoModalAction] = useState<null | "saveOnly" | "delete">(null);
  const [activeStep, setActiveStep] = useState(0);
  const [originalData, setOriginalData] = useState<any>({});
  const [mappedCourseOptions, setMappedCourseOptions] = useState<{ value: string; label: string }[]>([]);
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [formData, setFormData] = useState<any>({
    skipHours: 12,
    title: "",
    firstName: "",
    lastName: "",
    gender: "",
    mobileNumber: "",
    countryCode: "",
    timeZone: "",
    state: "",
    ageGroup: "",
    emailId: '',
    photoLink:"",
    Qualifications:"",
    yearsOfExperience:"",
    isAcademicExpert: false,
    payoutCategory:"",
    isBatchOnline: false,
    is1to1Enabled: false,
    onlyInternational: false,
    onlyDomestic: false,
    markedForOffers: false,
    enableForDemo: false,
    aeCourseCategoryId: '',


  
  });

  const config = useContext(ConfigContext);
  const { states = [], genders = [], timezones = [], ageGroups = [], countryCodes = []  , courses = [], languages=[]} = useContext(ConfigContext) || {};
  const airlineCourseCategories = config?.AirlineCourseCategory || [];
  // Group categories are hidden from this dropdown only; the full list above still
  // resolves a teacher's saved category, and other pages keep using the full config.
  // Matched on "group" because names/ids differ per env (UAT "Vocal-North Group"/16
  // vs prod "North-Vocals Group"/15 for Western).
  const profileCategoryOptions = airlineCourseCategories.filter(
    (category: { name: string }) => !/group/i.test(category.name || "")
  );
  console.log("confif", config)

  const normalizeCategoryKey = (value: string) =>
    value.trim().toLowerCase().replace(/[\s_-]+/g, '');

  const getCourseCategoryName = (teacher: any): string =>
    String(
      teacher?.courseCategory ||
      teacher?.teacherProfileDetails?.courseCategory ||
      ''
    ).trim();

  const resolveAeCourseCategoryId = (teacher: any): string => {
    const details = teacher?.teacherProfileDetails || {};
    const categoryName = getCourseCategoryName(teacher);
    const directId =
      details?.aeCourseCategoryId ??
      details?.courseCategoryId ??
      teacher?.aeCourseCategoryId ??
      teacher?.courseCategoryId;

    if (airlineCourseCategories.length) {
      if (directId != null && directId !== '') {
        const byCategoryId = airlineCourseCategories.find(
          (category: { id: number; categoryId: number }) =>
            String(category.categoryId) === String(directId)
        );
        if (byCategoryId) return String(byCategoryId.categoryId);

        const byId = airlineCourseCategories.find(
          (category: { id: number; categoryId: number }) =>
            String(category.id) === String(directId)
        );
        if (byId) return String(byId.categoryId);
      }

      if (categoryName) {
        const normalizedName = normalizeCategoryKey(categoryName);
        const byName = airlineCourseCategories.find((category: { name: string }) => {
          const name = String(category.name || '');
          return name === categoryName || normalizeCategoryKey(name) === normalizedName;
        });
        if (byName) return String(byName.categoryId);
      }
    }

    return directId != null && directId !== '' ? String(directId) : '';
  };

  const getCategoryLabel = (categoryId: string | number | null | undefined): string => {
    if (categoryId == null || categoryId === '') return 'Empty';
    const match = airlineCourseCategories.find(
      (category: { categoryId: number; name: string }) =>
        String(category.categoryId) === String(categoryId)
    );
    return match?.name || String(categoryId);
  };

  const languageOptions = languages.map((language:any) => ({
    value: language.id.toString(),
    label: language.name,
  }));
  
  const ageGroupOptions = ageGroups.map((ageGroup:any) => ({
    value: ageGroup.id.toString(),
    label: ageGroup.name,
  }));
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (readOnly) return;
    const { name, value, type, checked } = event.target;

    if (type === 'checkbox') {
      if (name === 'skipHours') {
        setPendingValue(checked);
        setFormData({ ...formData, [name]: checked ? 2 : 12 });
        setPendingToggleType('skipHours');
      } else if (name === 'isAcademicExpert') {
        setPendingPreviousIsAcademicExpert(!!formData.isAcademicExpert);
        setFormData({ ...formData, [name]: checked });
        setPendingToggleType('isAcademicExpert');
      } else {
        setFormData({ ...formData, [name]: checked });
      }
    }
    if (name === 'skipHours' || name === 'isAcademicExpert') {
      setShowConfirmation(true);
    }
  };

  
  useEffect(() => {
    if (teacherDetails) {
      const genderObj = genders.find((g: any) => g.name === teacherDetails?.teacherProfileDetails.gender);
      const genderId = genderObj ? genderObj.id.toString() : "";
      const teacherTimezone = teacherDetails?.teacherProfileDetails?.timezone || "";

      const selectedLanguages = teacherDetails.TeacherLanguage.map((language: any) => {
        const languageConfig = languages.find((l: any) => l.id.toString() === language.languageId);
        return {
          value: language.languageId,
          label: languageConfig ? languageConfig.name : `Unknown (ID: ${language.languageId})`
        };
      });
   

 
      const selectedAgeGroups = teacherDetails.TeacherAgeGroup.map((ageGroup: any) => {
        // Find matching age group in config
        const ageGroupConfig = ageGroups.find((ag: any) => 
          ag.id.toString() === ageGroup.ageGroupId.toString()
        );
        
        return {
          value: ageGroup.ageGroupId.toString(), // Ensure value is string
          label: ageGroupConfig ? ageGroupConfig.name : `Age Group ${ageGroup.ageGroupId}`
        };
      })
      const uniqueSelectedLanguages = selectedLanguages.filter(
        (lang: any, index: number, self: any[]) => 
          index === self.findIndex((l) => l.value === lang.value)
      );
      const profileDetails = teacherDetails?.teacherProfileDetails || {};
      const initialFormData = {
        userId: profileDetails?.userId || null,
        title:
          profileDetails?.TitleName ||
          profileDetails?.titleName ||
          teacherDetails?.TitleName ||
          teacherDetails?.titleName ||
          "",
        firstName: teacherDetails?.teacherProfileDetails.firstName || null,
        lastName: teacherDetails?.teacherProfileDetails.lastName || null,
        gender: teacherDetails.teacherGender,
        emailId: teacherDetails?.teacherProfileDetails.emailId || null,
        mobileNumber: teacherDetails?.teacherProfileDetails.mobileNumber || null,
        countryCode: teacherDetails?.teacherProfileDetails.countryCode || null,
        timezone: teacherDetails?.teacherProfileDetails?.timezone || null, 
        state:teacherDetails?.teacherProfileDetails.state || null,
        isBatchOnline:teacherDetails?.teacherProfileDetails.isBatchOnline || false,
        is1to1Enabled: teacherDetails?.teacherProfileDetails.is1to1Enabled || false,
        onlyInternational:teacherDetails?.teacherProfileDetails.onlyInternational || false,
        onlyDomestic: teacherDetails?.teacherProfileDetails.onlyDomestic || false,
        markedForOffers: teacherDetails?.teacherProfileDetails.markedForOffers || false,
        skipHours: teacherDetails?.skipHours || 12,
        enableForDemo: teacherDetails?.enableForDemo ?? teacherDetails?.teacherProfileDetails?.enableForDemo ?? false,
        isAcademicExpert: teacherDetails?.teacherProfileDetails.isAcademicExpert || false,
        photoLink: teacherDetails?.teacherProfileDetails.profilePhoto || null,
        videoLink:teacherDetails?.videolink || null,
        academicQualifications:teacherDetails?.teacherProfileDetails.academicQualifications || null,
        languages: uniqueSelectedLanguages,
        yearsOfExperience:teacherDetails?.teacherProfileDetails.yearsOfExperience || null,
        payoutCategory : teacherDetails?.teacherProfileDetails?.payoutCategory,
        ageGroup: selectedAgeGroups,
        description:teacherDetails?.teacherProfileDetails.description || null,
        courseCategory: getCourseCategoryName(teacherDetails),
        aeCourseCategoryId:
          resolveAeCourseCategoryId(teacherDetails) || getCourseCategoryName(teacherDetails),
      };

      setFormData(initialFormData);
      setOriginalData(initialFormData); // Store original data for comparison
      setIsLoading(false);
    }
  }, [teacherDetails, genders, timezones, languages, ageGroups, config?.AirlineCourseCategory]);

  useEffect(() => {
    if (!teacherDetails || !airlineCourseCategories.length) return;

    const resolvedCategoryId = resolveAeCourseCategoryId(teacherDetails);
    if (!resolvedCategoryId) return;

    setFormData((prev: any) => {
      if (String(prev.aeCourseCategoryId ?? '') === resolvedCategoryId) return prev;
      return { ...prev, aeCourseCategoryId: resolvedCategoryId };
    });
    setOriginalData((prev: any) => {
      if (String(prev.aeCourseCategoryId ?? '') === resolvedCategoryId) return prev;
      return { ...prev, aeCourseCategoryId: resolvedCategoryId };
    });
  }, [teacherDetails, config?.AirlineCourseCategory]);

  useEffect(() => {
    if (!teacherId) return;
    let cancelled = false;
    const loadCourses = async () => {
      setCoursesLoading(true);
      try {
        const list = await getTeacherMappedCourses(String(teacherId));
        if (cancelled) return;
        const levelOrder = ["Preparatory", "Intermediate", "Proficient", "Advanced"];
        const byName = new Map<string, { courseName: string; courseId?: string; levels: string[] }>();
        list.forEach((item) => {
          const name = item.courseName || "Untitled course";
          const existing = byName.get(name);
          if (!existing) {
            byName.set(name, {
              courseName: name,
              courseId: item.courseId,
              levels: item.level ? [item.level] : [],
            });
          } else if (item.level && !existing.levels.includes(item.level)) {
            existing.levels.push(item.level);
          }
        });
        const options = Array.from(byName.values()).map((course) => {
          const levels = [...course.levels].sort(
            (a, b) => levelOrder.indexOf(a) - levelOrder.indexOf(b)
          );
          return {
            value: String(course.courseId || course.courseName),
            label: levels.length
              ? `${course.courseName} (${levels.join(", ")})`
              : course.courseName,
          };
        });
        setMappedCourseOptions(options);
      } catch (error) {
        console.error("Error fetching teacher courses:", error);
        if (!cancelled) setMappedCourseOptions([]);
      } finally {
        if (!cancelled) setCoursesLoading(false);
      }
    };
    void loadCourses();
    return () => {
      cancelled = true;
    };
  }, [teacherId]);

  const handleCancel = () => {
    if (pendingToggleType === 'isAcademicExpert') {
      setFormData((prev: any) => ({ ...prev, isAcademicExpert: pendingPreviousIsAcademicExpert }));
    }
    setShowConfirmation(false);
    setPendingToggleType(null);
  };


  const handleSave = async (): Promise<boolean> => {
    if (readOnly) {
      toast.error("Editing is disabled for Teacher Leaders");
      return false;
    }
    try {
      const resolvedCategoryId = resolveAeCourseCategoryId({
        ...teacherDetails,
        aeCourseCategoryId: formData.aeCourseCategoryId,
        courseCategory: formData.courseCategory,
        teacherProfileDetails: {
          ...teacherDetails?.teacherProfileDetails,
          aeCourseCategoryId: formData.aeCourseCategoryId,
          courseCategory: formData.courseCategory,
        },
      });

      const categoryIdForSave = resolvedCategoryId || formData.aeCourseCategoryId;
      const hasValidCategory =
        categoryIdForSave != null &&
        String(categoryIdForSave).trim() !== '' &&
        !Number.isNaN(Number(categoryIdForSave));

      // Find changed fields
      const changedFields: any = {};
      const fieldLabels: any = {
        title: "Title",
        firstName: "First Name",
        lastName: "Last Name",
        gender: "Gender",
        emailId: "Email",
        mobileNumber: "Mobile Number",
        countryCode: "Country Code",
        timezone: "Time Zone",
        state: "State",
        ageGroup: "Age Group",
        photoLink: "Photo Link",
        videoLink: "Video Link",
        academicQualifications: "Academic Qualifications",
        yearsOfExperience: "Years of Experience",
        isAcademicExpert: "Is Academic Expert",
        payoutCategory: "Payout Category",
        isBatchOnline: "Eligible for Online Batches",
        is1to1Enabled: "Eligible for 1:1 Classes",
        onlyInternational: "Only International",
        onlyDomestic: "Only Domestic",
        markedForOffers: "Marked for Offers",
        skipHours: "Skip Hours",
        enableForDemo: "Enable for Demo",
        languages: "Preferred Languages",
        description: "Description",
        aeCourseCategoryId: "Category",
      };

      // Helper function to compare arrays
      const arraysEqual = (a: any[], b: any[]) => {
        if (!a || !b) return a === b;
        if (a.length !== b.length) return false;
        return a.every((val, index) => val.value === b[index]?.value);
      };

      Object.keys(formData).forEach(key => {
        if (key === 'ageGroup' || key === 'languages') {
          // Special handling for arrays
          if (!arraysEqual(formData[key], originalData[key])) {
            changedFields[key] = {
              oldValue: originalData[key]?.map((item: any) => item.label).join(', ') || "Empty",
              newValue: formData[key]?.map((item: any) => item.label).join(', ') || "Empty",
              fieldLabel: fieldLabels[key] || key
            };
          }
        } else if (key === 'aeCourseCategoryId') {
          if (String(formData[key] ?? '') !== String(originalData[key] ?? '')) {
            changedFields[key] = {
              oldValue: getCategoryLabel(originalData[key]),
              newValue: getCategoryLabel(formData[key]),
              fieldLabel: fieldLabels[key] || key,
            };
          }
        } else if (formData[key] !== originalData[key]) {
          changedFields[key] = {
            oldValue: originalData[key] || "Empty",
            newValue: formData[key] || "Empty",
            fieldLabel: fieldLabels[key] || key
          };
        }
      });

      const updateTimestamp = new Date().toISOString();

      const payload: any = {
        
   
        isOnlyInternational: formData.onlyInternational,
        isOnlydomestic: formData.onlyDomestic,
        isMarkedForOffers: formData.markedForOffers,
        userId: teacherDetails?.teacherProfileDetails?.userId, 
        academicQualifications: formData.academicQualifications,
        gender:formData.gender,
        teacherId: teacherId,
        titleName: formData.title || "",
        firstName: formData.firstName,
        lastName: formData.lastName,
        emailId: formData.emailId,
        password: formData.password || 'defaultPassword', // Ensure password is provided
        countrycode: formData.countryCode,
        mobileNumber: formData.mobileNumber,
        teacherGender: genders.find((g:any) => g.id.toString() === formData.gender)?.name || 'Male',
        ageGroupId: formData.ageGroup?.map((ag: any) =>  String(ag.value)) || [],
        state: formData.state,
        timeZone: formData.timezone,
        Teacherphotolink: formData.photoLink, 
        TeacherVideoLink: formData.videoLink, 
        employmentType: formData.employmentType,
        isAcademicExpert: formData.isAcademicExpert,    

        isBatchOnline: formData.isBatchOnline,
        is1to1Enabled: formData.is1to1Enabled,
        yearsOfExperience: formData.yearsOfExperience,
        preferredGender: genders.find((g:any) => g.id.toString() === formData.preferredGender)?.name || 'Male',
        languageId: formData.languages?.map((lang: any) =>  String(lang.value)) || [],
        payoutCategory: formData.payoutCategory,
        // courseId: formData.courses?.map((course: any) => course.value) || [],
        description: formData.description,
        skipHours: formData.skipHours  // Send the actual value (2 or 12)

      };

      // Category is optional on update — only send when a valid id is selected
      if (hasValidCategory) {
        payload.aeCourseCategoryId = Number(categoryIdForSave);
      }

      // Track only changed fields with timestamp
      trackEvent(MixpanelEvents.TEACHER_PROFILE_UPDATE, {
        page: "Teacher Form Update",
        teacherUserId: teacherDetails?.teacherProfileDetails?.userId,
        updateTimestamp: updateTimestamp,
        changedFields: changedFields,
        totalFieldsChanged: Object.keys(changedFields).length,
        hasChanges: Object.keys(changedFields).length > 0
      });
  
      console.log('Sending payload:', payload); // Debug log
  
      const response = await editTeacherProfile(payload);
  
      if (response) {
        toast.success("Data Updated Sucessfully");
        
        // Update original data after successful save
        setOriginalData(formData);
        
        fetchData (); 
        return true;
      } else {
        toast.error("Failed to update teacher profile");
        return false;
      }
    } catch (error) {
      console.error("Error updating teacher profile:", error);
      toast.error("Failed to update teacher profile");
      return false;
    }
  };

  const handleConfirm = async () => {
    try {
      await handleSave();
    } catch (error) {
      toast.error("Failed to update settings");
      if (pendingToggleType === 'skipHours') {
        setFormData((prev: any) => ({ ...prev, skipHours: pendingValue ? 12 : 2 }));
      }
      if (pendingToggleType === 'isAcademicExpert') {
        setFormData((prev: any) => ({ ...prev, isAcademicExpert: pendingPreviousIsAcademicExpert }));
      }
    } finally {
      setShowConfirmation(false);
      setPendingToggleType(null);
    }
  };
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (readOnly) return;
    const { name, value, type, checked } = event.target;

    if (name === "mobileNumber") {
      const maxDigits = String(formData.countryCode || "").trim() === "+91" ? 10 : 15;
      const digitsOnly = value.replace(/\D/g, "").slice(0, maxDigits);
      setFormData({ ...formData, mobileNumber: digitsOnly });
      return;
    }

    if (type === "checkbox") {
      if (name === "skipHours") {
        setFormData({ ...formData, [name]: checked ? 2 : 12 });
      } else {
        setFormData({ ...formData, [name]: checked });
      }
    } else if (name === "isAcademicExpert") {
      const nextBool = value === "True";
      if (formData.isAcademicExpert === true && nextBool === false) {
        setFormData({ ...formData, isAcademicExpert: false });
        setAeDemoModalAction(null);
        setShowAeDemoDisableModal(true);
        return;
      }
      setFormData({ ...formData, [name]: nextBool });
    } else if (
      name === "enableForPaid" ||
      name === "isBatchOnline" ||
      name === "is1to1Enabled" ||
      name === "onlyInternational" ||
      name === "onlyDomestic" ||
      name === "markedForOffers" ||
      name === "isKidsFriendly"
    ) {
      setFormData({ ...formData, [name]: value === "True" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleSelectChange = (selectedOptions:any, fieldName:any) => {
    if (readOnly) return;
    setFormData({ ...formData, [fieldName]: selectedOptions });
  };
  
  

  const nextStep = () => setActiveStep((prev) => Math.min(prev + 1, stepTitles.length - 1));
  const prevStep = () => setActiveStep((prev) => Math.max(prev - 1, 0));

  const handleAeDemoModalDismiss = () => {
    if (aeDemoModalBusy) return;
    setAeDemoModalAction(null);
    setFormData((prev: any) => ({ ...prev, isAcademicExpert: true }));
    setShowAeDemoDisableModal(false);
  };

  /** Cancel: persist Demo (AE) = False via profile save only; no bulk airline slot delete. */
  const handleAeDemoModalCancelSaveOnly = async () => {
    setAeDemoModalAction("saveOnly");
    setAeDemoModalBusy(true);
    try {
      const ok = await handleSave();
      if (ok) setShowAeDemoDisableModal(false);
    } finally {
      setAeDemoModalBusy(false);
      setAeDemoModalAction(null);
    }
  };

  /** Delete and confirm: save profile, then scheduler bulk-delete free AIRLINE slots. */
  const handleAeDemoModalDeleteAndConfirm = async () => {
    if (teacherId == null || teacherId === "") {
      toast.error("Teacher ID missing.");
      return;
    }
    setAeDemoModalAction("delete");
    setAeDemoModalBusy(true);
    try {
      const ok = await handleSave();
      if (!ok) return;
      const range = aeAirlineBulkDeleteRange();
      await bulkDeleteFreeSlots({
        teacherId: Number(teacherId),
        fromDate: range.fromDate,
        toDate: range.toDate,
        scope: AE_DEMO_DISABLE_BULK_SCOPE,
      });
      setShowAeDemoDisableModal(false);
    } catch (err: unknown) {
      const axiosMsg =
        typeof err === "object" && err !== null && "response" in err
          ? (err as { response?: { data?: { message?: string } } }).response?.data?.message
          : undefined;
      const fromError = err instanceof Error ? err.message : undefined;
      toast.error(
        axiosMsg ||
          fromError ||
          "Profile may be saved, but bulk-delete AE free slots failed. Try again."
      );
    } finally {
      setAeDemoModalBusy(false);
      setAeDemoModalAction(null);
    }
  };

  const countryCodeOptions = useMemo(
    () =>
      (countryCodes || []).map((code: any): { value: string; label: string } => ({
        value: String(code.countryCode ?? ""),
        label: String(code.countryCode ?? ""),
      })),
    [countryCodes]
  );

  const selectedCountryCodeOption =
    countryCodeOptions.find(
      (opt: { value: string; label: string }) =>
        opt.value === String(formData.countryCode || "")
    ) || null;

  const timezoneOptions = useMemo(
    () =>
      (timezones || []).map((tz: any): { value: string; label: string } => ({
        value: String(tz.type ?? ""),
        label: String(tz.type ?? ""),
      })),
    [timezones]
  );

  const selectedTimezoneOption =
    timezoneOptions.find(
      (opt: { value: string; label: string }) =>
        opt.value === String(formData.timezone || "")
    ) || null;

  const searchableSelectStyles = {
    control: (base: any, state: any) => ({
      ...base,
      minHeight: 38,
      borderRadius: "var(--ds-radius-sm)",
      borderColor: state.isFocused ? "var(--ds-primary)" : "var(--ds-border-strong)",
      boxShadow: state.isFocused ? "var(--ds-focus-ring)" : "none",
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: "2px 8px",
    }),
    input: (base: any) => ({
      ...base,
      margin: 0,
      padding: 0,
      border: "none",
      outline: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
    }),
    singleValue: (base: any) => ({
      ...base,
      margin: 0,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    menu: (base: any) => ({ ...base, zIndex: 9999 }),
  };

  // ui Select emits a select change event; the shared handler only reads name/value/type/checked.
  const handleSelectInputChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    handleInputChange(event as unknown as React.ChangeEvent<HTMLInputElement>);

  const genderOptions: SelectOption[] = [
    { value: "", label: "Select Gender" },
    ...(genders || []).map((gender: any) => ({ value: String(gender.name), label: String(gender.name) })),
  ];

  return (
    <div className="tp-form">
      <div className="tp-form__toggle">
        <SwitchField
          id="tp-form-skipHours"
          label="Accept 2 hours advanced booking"
          name="skipHours"
          checked={formData.skipHours === 2 }
          onChange={handleToggleChange}
          disabled={readOnly}
          title={readOnly ? "Disabled for Teacher Leaders" : undefined}
        />
      </div>

      {/* Enable for Demo toggle (name="isAcademicExpert", onChange={handleToggleChange}) is disabled; the
          "Enable for Demo(AE)" select in Academic Details is used instead. */}

      {/* Confirmation Modal */}
      <Modal isOpen={showConfirmation} toggle={handleCancel}>
        <ModalHeader toggle={handleCancel}>Confirm Change</ModalHeader>
        <ModalBody>
          {pendingToggleType === 'skipHours' && (
            <>Are you sure you want to {pendingValue ? "enable" : "disable"} 2-hour advanced booking?</>
          )}
          {pendingToggleType === 'isAcademicExpert' && (
            <>Are you sure you want to {formData.isAcademicExpert ? "enable" : "disable"} this teacher for Demo?</>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={showAeDemoDisableModal}
        toggle={handleAeDemoModalDismiss}
        backdrop={aeDemoModalBusy ? "static" : true}
        keyboard={!aeDemoModalBusy}
      >
        <ModalHeader toggle={handleAeDemoModalDismiss}>Disable Demo (AE)?</ModalHeader>
        <ModalBody className="tp-form__modal-body">
          <p>{`You turned off "Enable for Demo (AE)".`}</p>
          <p className="ds-text-muted tp-form__modal-note">
          ✅ <b>Delete and Save:</b> Saves the teacher profile and bulk-deletes all associated AE airline slots.
          </p>
          {/* <p className="ds-text-muted tp-form__modal-note">
          ✅ <b>Save Only:</b> Saves the teacher profile (disabling Demo) but keeps existing AE airline slots intact.
          </p> */}
        </ModalBody>
        <ModalFooter>
          {/* <Button variant="secondary" onClick={handleAeDemoModalCancelSaveOnly} disabled={aeDemoModalBusy}>
            {aeDemoModalBusy && aeDemoModalAction === "saveOnly" ? "Saving…" : "Save Only"}
          </Button> */}
          <Button variant="danger" onClick={handleAeDemoModalDeleteAndConfirm} disabled={aeDemoModalBusy}>
            {aeDemoModalBusy && aeDemoModalAction === "delete" ? "Working…" : "Delete and Save"}
          </Button>
        </ModalFooter>
      </Modal>

      <SegmentedControl
        label="Profile sections"
        className="tp-form__steps"
        value={String(activeStep)}
        onChange={(value) => setActiveStep(Number(value))}
        options={stepTitles.map((title, index) => ({
          value: String(index),
          label: (
            <span className="tp-form__step">
              <i className={`fa ${STEP_ICONS[index]}`} aria-hidden />
              {title}
            </span>
          ),
        }))}
      />

      {/* Step Forms */}
      <Form>
        <fieldset disabled={readOnly} className="tp-form__fieldset">
          {activeStep === 0 && (
            <div className="tp-form__grid">
              <Field label="First Name" required id="tp-form-firstName">
                {(control) => (
                  <div className="tp-form__split">
                    <DsSelect
                      aria-label="Title"
                      name="title"
                      value={formData.title || ''}
                      onChange={handleSelectInputChange}
                      options={TITLE_OPTIONS}
                    />
                    <TextInput {...control} type="text" name="firstName" value={formData.firstName || ''} onChange={handleInputChange} />
                  </div>
                )}
              </Field>

              <Field label="Last Name" required id="tp-form-lastName">
                {(control) => (
                  <TextInput {...control} type="text" name="lastName" placeholder={EnterLastName} value={formData.lastName || ''} onChange={handleInputChange} />
                )}
              </Field>

              <Field label="Gender" required id="tp-form-gender">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="gender"
                    value={formData.gender}
                    onChange={handleSelectInputChange}
                    options={genderOptions}
                  />
                )}
              </Field>

              <Field label="Email" required id="tp-form-emailId">
                {(control) => (
                  <TextInput {...control} placeholder={EmailJobPlaceholder} type="email" name="emailId" value={formData.emailId || ''} onChange={handleInputChange} />
                )}
              </Field>

              <Field label="Mobile Number" required id="tp-form-mobileNumber">
                {(control) => (
                  <div className="tp-form__split">
                    <Select
                      aria-label="Country code"
                      options={countryCodeOptions}
                      value={selectedCountryCodeOption}
                      onChange={(option) => {
                        if (readOnly) return;
                        const nextCode = option?.value || "";
                        const maxDigits = String(nextCode).trim() === "+91" ? 10 : 15;
                        const nextMobile = String(formData.mobileNumber || "")
                          .replace(/\D/g, "")
                          .slice(0, maxDigits);
                        setFormData({
                          ...formData,
                          countryCode: nextCode,
                          mobileNumber: nextMobile,
                        });
                      }}
                      isDisabled={readOnly}
                      isSearchable
                      isClearable
                      placeholder="Code"
                      noOptionsMessage={() => "No match"}
                      filterOption={(option, rawInput) => {
                        const q = rawInput.trim().toLowerCase().replace(/\s+/g, "");
                        if (!q) return true;
                        const label = String(option.label)
                          .toLowerCase()
                          .replace(/\s+/g, "");
                        return (
                          label.includes(q) ||
                          label.replace(/^\+/, "").includes(q.replace(/^\+/, ""))
                        );
                      }}
                      menuPortalTarget={
                        typeof document !== "undefined" ? document.body : null
                      }
                      menuPosition="fixed"
                      menuPlacement="auto"
                      classNamePrefix="country-code-select"
                      styles={searchableSelectStyles}
                    />
                    <TextInput
                      {...control}
                      type="tel"
                      placeholder={DelimiterPlaceholder}
                      name="mobileNumber"
                      value={formData.mobileNumber || ""}
                      onChange={handleInputChange}
                      maxLength={String(formData.countryCode || "").trim() === "+91" ? 10 : 15}
                      inputMode="numeric"
                    />
                  </div>
                )}
              </Field>

              <Field label="Time Zone" required id="tp-form-timezone">
                {(control) => (
                  <Select
                    inputId={control.id}
                    options={timezoneOptions}
                    value={selectedTimezoneOption}
                    onChange={(option) => {
                      if (readOnly) return;
                      setFormData({
                        ...formData,
                        timezone: option?.value || "",
                      });
                    }}
                    isDisabled={readOnly}
                    isSearchable
                    isClearable
                    placeholder="Search or select time zone"
                    noOptionsMessage={() => "No matching time zone"}
                    filterOption={(option, rawInput) => {
                      const q = rawInput.trim().toLowerCase();
                      if (!q) return true;
                      const label = String(option.label).toLowerCase();
                      const city = label.includes("/")
                        ? label.split("/").pop() || ""
                        : label;
                      return (
                        label.includes(q) ||
                        city.includes(q) ||
                        label.replace(/[_/]/g, " ").includes(q)
                      );
                    }}
                    menuPortalTarget={
                      typeof document !== "undefined" ? document.body : null
                    }
                    menuPosition="fixed"
                    menuPlacement="auto"
                    classNamePrefix="timezone-select"
                    styles={searchableSelectStyles}
                  />
                )}
              </Field>

              <Field label="State" id="tp-form-state">
                {(control) => (
                  // Native select: needs a disabled "Loading states..." placeholder option.
                  <select {...control} className="ds-select" name="state" value={formData.state} onChange={handleSelectInputChange}>
                    <option value="">Select State</option>
                    {states.length > 0 ? (
                      states.map((state: string, index: number) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))
                    ) : (
                      <option disabled>Loading states...</option>
                    )}
                  </select>
                )}
              </Field>

              <Field label="Photo Link" id="tp-form-photoLink">
                {(control) => (
                  <TextInput {...control} type="text" name="photoLink" value={formData.photoLink || ''} onChange={handleInputChange} />
                )}
              </Field>

              <Field label="Video Link" id="tp-form-videoLink">
                {(control) => (
                  <TextInput {...control} type="text" name="videoLink" value={formData.videoLink || ''} onChange={handleInputChange} />
                )}
              </Field>

              <Field label="Payout Category" id="tp-form-payoutCategory">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="payoutCategory"
                    value={formData.payoutCategory || ''}
                    disabled={!isAllowed}
                    onChange={handleSelectInputChange}
                    options={PAYOUT_OPTIONS}
                  />
                )}
              </Field>
            </div>
          )}

          {activeStep === 1 && (
            <div className="tp-form__grid">
              <Field label="Academic Qualifications" required id="tp-form-academicQualifications">
                {(control) => (
                  <TextInput {...control} type="text" name="academicQualifications" value={formData.academicQualifications || ''} onChange={handleInputChange} />
                )}
              </Field>
              <Field label="Years of Experience" required id="tp-form-yearsOfExperience">
                {(control) => (
                  <TextInput {...control} type="number" name="yearsOfExperience" value={formData.yearsOfExperience || ''} onChange={handleInputChange} />
                )}
              </Field>
              <Field label="Enable for Demo(AE)" required id="tp-form-isAcademicExpert">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="isAcademicExpert"
                    value={formData.isAcademicExpert ? 'True' : 'False'}
                    onChange={handleSelectInputChange}
                    options={TRUE_FALSE_OPTIONS}
                  />
                )}
              </Field>
            </div>
          )}

          {activeStep === 2 && (
            <div className="tp-form__grid">
              <Field label="Employment Type" required id="tp-form-employmentType">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="employmentType"
                    value={formData.employmentType || ''}
                    onChange={handleSelectInputChange}
                    options={EMPLOYMENT_OPTIONS}
                  />
                )}
              </Field>
              <Field label="Eligible for Online Batches" required id="tp-form-isBatchOnline">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="isBatchOnline"
                    value={formData.isBatchOnline  ? 'True' : 'False' }
                    onChange={handleSelectInputChange}
                    options={TRUE_FALSE_OPTIONS}
                  />
                )}
              </Field>
              <Field label="Eligible for 1:1 Classes" required id="tp-form-is1to1Enabled">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="is1to1Enabled"
                    value={formData.is1to1Enabled  ? 'True' : 'False' }
                    onChange={handleSelectInputChange}
                    options={TRUE_FALSE_OPTIONS}
                  />
                )}
              </Field>
            </div>
          )}

          {activeStep === 3 && (
            <div className="tp-form__grid">
              <Field label="Only International" required id="tp-form-onlyInternational">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="onlyInternational"
                    value={formData.onlyInternational  ? 'True' : 'False' }
                    onChange={handleSelectInputChange}
                    options={TRUE_FALSE_OPTIONS}
                  />
                )}
              </Field>
              <Field label="Only Domestic" required id="tp-form-onlyDomestic">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="onlyDomestic"
                    value={formData.onlyDomestic  ? 'True' : 'False' }
                    onChange={handleSelectInputChange}
                    options={TRUE_FALSE_OPTIONS}
                  />
                )}
              </Field>
              <Field label="Marked for Offers" required id="tp-form-markedForOffers">
                {(control) => (
                  <DsSelect
                    {...control}
                    name="markedForOffers"
                    value={formData.markedForOffers  ? 'True' : 'False'  }
                    onChange={handleSelectInputChange}
                    options={TRUE_FALSE_OPTIONS}
                  />
                )}
              </Field>
              <Field label="Age Group" id="tp-form-ageGroup">
                {(control) => (
                  <Select
                    inputId={control.id}
                    name="ageGroup"
                    isMulti
                    isDisabled={readOnly}
                    value={formData.ageGroup}
                    options={ageGroupOptions}
                    onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'ageGroup')}
                    placeholder="Select age group"
                  />
                )}
              </Field>
              <Field label="Preferred Language" id="tp-form-languages">
                {(control) => (
                  <Select
                    inputId={control.id}
                    name="languages"
                    isMulti
                    isDisabled={readOnly}
                    value={formData.languages}
                    options={languageOptions}
                    onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'languages')}
                    placeholder="Select Language"
                  />
                )}
              </Field>

              {/* Courses multi-select (formData.courses / courseOptions) is disabled; courses are
                  edited in Course Tagging and shown read-only below. */}

              <Field label="Description" required id="tp-form-description">
                {(control) => (
                  <Input {...control} type="textarea" name="description" value={formData.description || ''} onChange={handleInputChange} />
                )}
              </Field>
              <Field label="Category" id="tp-form-aeCourseCategoryId">
                {(control) => (
                  // Native select: category ids can repeat across config rows, so options keep index keys.
                  <select
                    {...control}
                    className="ds-select"
                    name="aeCourseCategoryId"
                    value={formData.aeCourseCategoryId || ''}
                    onChange={handleSelectInputChange}
                  >
                    <option value="">Select Category</option>
                    {profileCategoryOptions.map(
                      (category: { id: number; name: string; categoryId: number }, index: number) => (
                        <option
                          key={`${category.id}-${category.categoryId}-${index}`}
                          value={String(category.categoryId)}
                        >
                          {category.name}
                        </option>
                      )
                    )}
                    {formData.courseCategory &&
                      !profileCategoryOptions.some(
                        (category: { categoryId: number }) =>
                          String(category.categoryId) === String(formData.aeCourseCategoryId)
                      ) && (
                        <option value={String(formData.aeCourseCategoryId || formData.courseCategory)}>
                          {formData.courseCategory}
                        </option>
                      )}
                  </select>
                )}
              </Field>
              <Field
                label="Courses"
                hint="View only — edit in Course Tagging"
                id="tp-form-courses"
                className="tp-form__full"
              >
                {(control) =>
                  coursesLoading ? (
                    <Loader label="Loading courses…" />
                  ) : (
                    <Select
                      inputId={control.id}
                      aria-describedby={control["aria-describedby"]}
                      isMulti
                      isDisabled
                      isClearable={false}
                      isSearchable={false}
                      value={mappedCourseOptions}
                      options={mappedCourseOptions}
                      placeholder="No courses tagged yet"
                      classNamePrefix="react-select"
                      components={{
                        MultiValueRemove: () => null,
                        ClearIndicator: () => null,
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      styles={{
                        multiValueRemove: () => ({ display: "none" }),
                      }}
                    />
                  )
                }
              </Field>
            </div>
          )}
        </fieldset>
      </Form>

      {/* Navigation Buttons */}
      <div className="tp-form__actions">
        <Button variant="secondary" onClick={prevStep} disabled={activeStep === 0}>Back</Button>
        {/* {activeStep !== stepTitles.length - 1 && <Button variant="primary" onClick={nextStep}>Next</Button>} */}
        <Button variant="primary" onClick={handleSave} disabled={readOnly} title={readOnly ? "Disabled for Teacher Leaders" : undefined}>Save</Button>
      </div>
    </div>
  );
};

export default FormProfile;
